import type { ReactNode } from "react";

interface RadioOptionProps {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  align?: "center" | "start";
}

export function RadioOption({ selected, onClick, children, align = "center" }: RadioOptionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full gap-3 rounded-2xl border bg-bgWhite p-4 text-left transition-colors ${
        align === "start" ? "items-start" : "items-center"
      } ${selected ? "border-textDark" : "border-borderDefault"}`}
    >
      <div
        className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors ${
          align === "start" ? "mt-0.5" : ""
        } ${selected ? "border-textDark bg-textDark" : "border-borderDefault bg-bgWhite"}`}
      >
        {selected && <div className="h-2 w-2 rounded-full bg-bgWhite" />}
      </div>
      {children}
    </button>
  );
}
